import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

const NavLinks = ({ links, direction ,loggedIn}) => {
  const [activeLink, setActiveLink] = useState(null);
  const [submenuOpen, setSubmenuOpen] = useState(false);
  const location = useLocation(); // Get current URL path
  let timer;
  // Handle showing submenu (on mouse enter)
  const handleMouseEnter = (index) => {
    clearTimeout(timer);
    setActiveLink(index);
    setSubmenuOpen(true);
  };

  // Handle hiding submenu (with a delay)
  const handleMouseLeave = () => {
    timer = setTimeout(() => {
      setSubmenuOpen(false);
      setActiveLink(null);
    }, 200);
  };

  // Toggle dropdown on click
  const toggleDropdown = (index) => {
    setActiveLink(activeLink === index ? null : index);
  };

  // Determine if the link is active based on the current URL
  const isActiveLink = (linkHref) => location.pathname === linkHref;

  // Determine if any sublink is active
  const isActiveSublink = (sublinkHref) => location.pathname === sublinkHref;

  // Check if any sublink is active and propagate active state to the parent link
  const isServiceLinkActive = (sublinks) => {
    return sublinks.some((sublink) => isActiveSublink(sublink.href));
  };

  return (
    <Box className="nav-links" sx={{ direction }}>
      {links.map((link, index) => (
        <Box
          key={index}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          sx={{ position: 'relative' }}
        >
          <Typography
           component={Link}
            to={link.href}
            className={`nav-item ${isActiveLink(link.href) || (link.sublinks && isServiceLinkActive(link.sublinks)) ? 'active' : ''}`}
            display="flex"
            alignItems="center"
            gap={1}
            onClick={() => toggleDropdown(index)}
            sx={{
              fontSize: { xs: '12px', md: '14px', lg: '18px', xl: '20px' },
              fontWeight: { xs: 400, md: 700, lg: 600 },
              lineHeight: { xs: '16px', md: '20px' },
              color: isActiveLink(link.href) || (link.sublinks && isServiceLinkActive(link.sublinks)) ? 'var(--primary-color)' : 'var(--text-color)',
              textAlign: direction === 'rtl' ? 'right' : 'left',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              flexDirection: 'row', // Icon to the left, label to the right
            }}
          >
            {link.icon}
            {link.label}
            {link.sublinks && (
              <Box
                sx={{
                  transition: 'transform 0.3s ease',
                  transform: activeLink === index ? 'rotate(180deg)' : 'rotate(0deg)',
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                {activeLink === index ? <FaAngleUp /> : <FaAngleDown />}
              </Box>
            )}
          </Typography>

          {/* Dropdown items */}
          {link.sublinks && activeLink === index && submenuOpen && (
            <Box
              sx={{
                position: 'absolute',
                top: '100%',
                left: direction === 'rtl' ? 'auto' : 0,
                right: direction === 'rtl' ? 0 : 'auto',
                backgroundColor: '#fff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                marginTop: '10px',
                borderRadius: '4px',
                zIndex: 100,
                width: '250px',
                minWidth: '200px',
              }}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              {link.sublinks.map((sublink, subIndex) => (
                <Typography
                component={Link}
                to={sublink.href} 
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top
                }}
                className={isActiveSublink(sublink.href) ? 'active subnav-item' : 'subnav-item'}
                  sx={{
                    display: 'block',
                    padding: '10px 15px',
                    fontSize: '16px',
                    color: isActiveSublink(sublink.href) ? 'var(--primary-color)' : '#000',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.05)',
                    },
                  }}
                >
                  {sublink.label}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default NavLinks;
